export const iconFontAwesomeCharityHeart = (
	<i className="fa-solid fa-heart"></i>
);
